import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { IVariant } from "repoV2/features/Listing/Listing.interfaces";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import { selected_merchandise_variant_form_key } from "../MerchandiseDetailsFormGroup.constants";

const useMerchandiseHelper = () => {
    const { watch } = useFormContext();

    const { listingUuid, isShiprocketEnabled } =
        useCheckoutBasicDetailsContext();

    const { variants = {} } =
        useSelector(
            (state: IRepoV2ReduxState) =>
                state.checkoutPages.listingDetails?.[listingUuid]
                    ?.merchandiseVariantsDetails?.data
        ) || {};

    const isVariantMerchandise = Boolean(Object.keys(variants).length);

    const selectedMerchandiseVariant: IVariant =
        watch(selected_merchandise_variant_form_key) || {};

    const shiprocketData =
        useSelector(
            (state: IRepoV2ReduxState) =>
                state.checkoutPages.listingDetails?.[listingUuid]
                    ?.merchandiseShiprocketDetails?.data
        ) || {};

    return {
        isVariantMerchandise,
        selectedMerchandiseVariant,
        shiprocketData,
        isShiprocketEnabled,
    };
};

export default useMerchandiseHelper;
